import React from 'react';

export default function StartupScreen({ error, progress, tip }) {
  return (
    <div className="loading">
      {!error && <img src="/123.gif" alt="Загрузка..." />}
      <p>{error || 'Загрузка...'}</p>
      {!error && (
        <>
          <div className="loading-progress-container" aria-label={`Загружено ${progress}%`}>
            <div className="loading-progress-bar" style={{ width: `${progress}%` }} />
          </div>
          <p className="random-tip">{tip}</p>
        </>
      )}
    </div>
  );
}
